import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

export const SidebarData = [
  {
    title: 'Home',
    path: '/admin',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text'
  },
  {
    title: 'Clubs',
    path: '/admin/clubs',
    icon: <IoIcons.IoIosBusiness />,
    cName: 'nav-text'
  },
  {
    title: 'Programs',
    path: '/admin/programs',
    icon: <IoIcons.IoIosFootball />,
    cName: 'nav-text'
  },
  {
    title: 'Players',
    path: '/admin/players',
    icon: <IoIcons.IoMdPeople />,
    cName: 'nav-text'
  },
  {
    title: 'Payments',
    path: '/admin/payments',
    icon: <FaIcons.FaMoneyBill />,
    cName: 'nav-text'
  },
  {
    title: 'Account',
    path: '/admin/user',
    icon: <IoIcons.IoIosPerson />,
    cName: 'nav-text'
  },
  // {
  //   title: 'Messages',
  //   path: '/admin/messages',
  //   icon: <FaIcons.FaEnvelopeOpenText />,
  //   cName: 'nav-text'
  // },
  {
    title: 'Support',
    path: '/admin/support',
    icon: <IoIcons.IoMdHelpCircle />,
    cName: 'nav-text'
  },
  {
    title: 'Sign Out',
    path: '#',
    icon: <IoIcons.IoMdLogOut />,
    cName: 'nav-text logout-sidebar-button'
  }
];